module.exports = __webpack_public_path__ + "img/logo.a0d72bb1.svg";